import GroupedCheckbox from './GroupedCheckbox';

export * from './GroupedCheckbox';
export default GroupedCheckbox;
